import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {RegionSettings} from 'src/openapi/admin/models/RegionSettings';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

type LcdSubscriptionsData = Record<string, Record<string, Array<RegionSettings>>>;

export const userSearchResultLcdSubscriptionsSlice = getCachedTableDataSlice<
    LcdSubscriptionsData,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultLcdSubscriptions');

export const userSearchResultLcdSubscriptionsActions = userSearchResultLcdSubscriptionsSlice.actions;

const userSearchResultLcdSubscriptionsCacheSelector: CachedTableCacheSelector<LcdSubscriptionsData>
    = state => state.userSearchResult.lcdSubscriptions.cache;
export const userSearchResultLcdSubscriptionsDataSelector: CachedTableDataSelector<LcdSubscriptionsData>
    = state => state.userSearchResult.lcdSubscriptions;
export const userSearchResultLcdSubscriptionsResultSelector = getCachedTableResultSelector(
    userSearchResultLcdSubscriptionsCacheSelector,
    userSearchResultStateSelector,
);
